"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _formatMessage = _interopRequireDefault(require("../format-message"));

/*
 * Copyright (C) 2018 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */
var locale = {
  alternative_text_a834dcad: {
    message: "L\xF2t T\xE8ks:"
  },
  announcement_list_da155734: {
    message: "Lis Anons"
  },
  announcements_a4b8ed4a: {
    message: "Anons"
  },
  assignments_1e02582c: {
    message: "Sesyon"
  },
  background_color_press_down_to_select_ef99fdac: {
    message: "Koul\xE8 Fon, peze anba pou ka seleksyone"
  },
  c_2001_acme_inc_283f7f80: {
    message: "(c) 2001 Acme Inc."
  },
  cancel_file_upload_9903e7b9: {
    message: "Anile transf\xE8 fichye"
  },
  cancel_image_upload_2c771950: {
    message: "Anile transf\xE8 imaj"
  },
  cc_attribution_f6de631f: {
    message: "Atribisyon CC"
  },
  cc_attribution_no_derivatives_b006744f: {
    message: "Atribisyon CC San Enstriman Derive"
  },
  cc_attribution_non_commercial_39e0d30d: {
    message: "Atribisyon CC Non Kom\xE8syal"
  },
  cc_attribution_non_commercial_no_derivatives_9fe74c00: {
    message: "Atribisyon CC Non Kom\xE8syal San Enstriman Derive"
  },
  cc_attribution_non_commercial_share_alike_c7edb1e5: {
    message: "Atribisyon CC Non Kom\xE8syal Pataje Menm Jan"
  },
  cc_attribution_share_alike_669e7f16: {
    message: "Atribisyon CC Pataje Menm Jan"
  },
  check_if_the_image_is_decorative_283649b7: {
    message: "Verifye si imaj la dekoratif"
  },
  choose_usage_rights_33683854: {
    message: "Itilizasyon dwa itilizasyon..."
  },
  click_any_file_to_insert_a_download_link_for_that__a708fa4c: {
    message: "Klike sou nenp\xF2t fichye pou ensere yon lyen telechajan pou fichye sa a."
  },
  click_any_image_to_embed_the_image_in_the_page_2cdd1136: {
    message: "Klike sou nenp\xF2t imaj pou ensere imaj la nan paj la."
  },
  click_any_page_to_insert_a_link_to_that_page_ac920c02: {
    message: "Klike sou nenp\xF2t paj pou ensere yon lyen nan paj sa a."
  },
  click_to_embed_image_33107dd8: {
    message: "Klike pou entegre imaj"
  },
  click_to_embed_imagename_c41ea8df: {
    message: "Klike pou entegre { imageName }"
  },
  click_to_insert_a_link_into_the_editor_c19613aa: {
    message: "Klike pou ensere yon lyen nan edit\xE8 a"
  },
  click_to_insert_a_link_to_this_item_39794098: {
    message: "Klike pou ensere yon lyen nan eleman sa a."
  },
  close_flickr_form_b32e600a: {
    message: "F\xE8men f\xF2mil\xE8 Flickr"
  },
  collaborations_5c56c15f: {
    message: "Kolaborasyon"
  },
  copyright_holder_66ee111: {
    message: "Titil\xE8 Dwa Ot\xE8:"
  },
  course_navigation_dd035109: {
    message: "Navigasyon Kou"
  },
  creative_commons_license_725584ae: {
    message: "Lisans Creative Commons"
  },
  decorative_image_fde98579: {
    message: "Imaj Dekoratif"
  },
  discussions_a5f96392: {
    message: "Diskisyon"
  },
  discussions_index_6c36ced: {
    message: "Endis Diskisyon"
  },
  embed_image_1080badc: {
    message: "Entegre Imaj"
  },
  enter_search_terms_e397b1f0: {
    message: "antre t\xE8m rech\xE8ch"
  },
  enter_the_alternative_text_for_this_image_88047c47: {
    message: "Antre yon l\xF2t t\xE8ks pou imaj sa a"
  },
  file_upload_form_4aaad554: {
    message: "F\xF2mil\xE8 Transf\xE8 Fichye"
  },
  files_c300e900: {
    message: "Fichye"
  },
  files_index_af7c662b: {
    message: "Endis Fichye"
  },
  folder_705fd2d7: {
    message: "Dosye"
  },
  font_size_press_down_to_select_6c25dc2d: {
    message: "Gwos\xE8 T\xE8ks, peze anba pou ka seleksyone"
  },
  formatting_press_down_to_select_df728c30: {
    message: "F\xF2mataj, peze anba pou ka seleksyone"
  },
  grades_a61eba0a: {
    message: "N\xF2t"
  },
  group_navigation_99f191a: {
    message: "Navigasyon Gwoup"
  },
  i_have_obtained_permission_to_use_this_file_6386f087: {
    message: "Mwen gen otorizasyon pou itilize fichye sa a."
  },
  i_hold_the_copyright_71ee91b1: {
    message: "Mwen gen dwa dot\xE8 a"
  },
  if_you_do_not_select_usage_rights_now_this_file_wi_14e07ab5: {
    message: "Si w pa chwazi dwa itilizasyon yo kounye a, fichye sa a pa p pibliye apr\xE8 w fin transfere li."
  },
  image_upload_form_7b74079a: {
    message: "F\xF2mil\xE8 Transf\xE8 Imaj"
  },
  images_7ce26570: {
    message: "Imaj"
  },
  insert_equella_links_49a8dacd: {
    message: "Ensere lyen Equella"
  },
  insert_link_6dc23cae: {
    message: "Enseye Lyen"
  },
  insert_math_equation_57c6e767: {
    message: "Ensere Ekwasyon Matematik"
  },
  link_7262adec: {
    message: "Lyen"
  },
  link_to_a_new_page_6c4ad034: {
    message: "Lyen a yon Nouvo Paj"
  },
  link_to_other_content_in_the_course_879163b5: {
    message: "Lye a l\xF2t kontni nan kou a."
  },
  link_to_other_content_in_the_group_3fe25379: {
    message: "Lye a l\xF2t kontni nan gwoup la."
  },
  link_to_url_52dd935c: {
    message: "Lyen pou ale nan URL"
  },
  links_14b70841: {
    message: "Lyen"
  },
  load_more_results_460f49a9: {
    message: "Chaje plis rezilta"
  },
  loading_25990131: {
    message: "Chajman..."
  },
  loading_failed_b3524381: {
    message: "Chajman echwe..."
  },
  loading_folders_8d4d5d5a: {
    message: "Chajman dosye..."
  },
  modules_c4325335: {
    message: "Modil"
  },
  no_results_940393cf: {
    message: "Okenn rezilta."
  },
  pages_e5414c2c: {
    message: "Paj"
  },
  people_b4ebb13c: {
    message: "Moun"
  },
  quizzes_7e598f57: {
    message: "Quiz"
  },
  record_upload_media_5fdce166: {
    message: "Anrejistre/Chaje Medya"
  },
  rich_text_area_press_alt_f8_for_help_58f0f2c3: {
    message: "Z\xF2n Teks Rich Peze ALT+F8 pou w ka jwenn \xE8d"
  },
  search_280d00bd: {
    message: "Ch\xE8che"
  },
  search_flickr_6884b518: {
    message: "Ch\xE8che sou Flickr"
  },
  select_a_file_53ba40ac: {
    message: "Seleksyone yon fichye"
  },
  select_a_folder_to_upload_your_file_into_b82d12b: {
    message: "Seleksyone yon dosye pou transfere fichye ou a ladan li"
  },
  syllabus_f191f65b: {
    message: "Pwogram"
  },
  text_color_press_down_to_select_8f5ad9b5: {
    message: "Koul\xE8 T\xE8ks, peze anba pou ka seleksyone"
  },
  the_material_is_in_the_public_domain_279c39a3: {
    message: "Matery\xE8l la nan dom\xE8n piblik la"
  },
  the_material_is_licensed_under_creative_commons_3242cb5e: {
    message: "Matery\xE8l la distribye sou lisans Creative Commons"
  },
  the_material_is_subject_to_fair_use_exception_41bc6a4b: {
    message: "Matery\xE8l la f\xE8 obj\xE8 de yon eksepsyon itilizasyon ekitab"
  },
  this_upload_exceeds_the_file_storage_quota_please__c3a1b641: {
    message: "Chajman sa a depase kantite ke w ka estoke a. Tanpri pale a administrat\xE8 sist\xE8m ou an."
  },
  upload_8b403d05: {
    message: "Chajman"
  },
  upload_a_new_file_96e6d4ff: {
    message: "Transfere yon nouvo fichye"
  },
  upload_a_new_image_890df275: {
    message: "Transfere yon nouvo imaj"
  },
  usage_right_ff96f3e2: {
    message: "Dwa Itilizasyon:"
  },
  what_would_you_like_to_call_the_new_page_d7e4488a: {
    message: "Ki non ou te ka bay nouvo paj la?"
  },
  wiki_home_9cd54d0: {
    message: "Ak\xE8y Wiki"
  }
};

_formatMessage.default.addLocale({
  ht: locale
});